import { createModel } from "@rematch/core";
import moment from "moment";
import { CountState, DashboardFilterState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, multiRequest, signoutIfUnauthorized } from "./utilities";

const initialState: CountState = {
  churnCount: 0,
  churnCountBeginTimestamp: null,
  churnCountEndTimestamp: null,
  contractElectricityCount: 0,
  contractGasCount: 0,
  contractHeatingCount: 0,
  contractGlassFiberCount: 0,
  customerCount: 0,
  loading: false,
  pending: null,
};

export const count = createModel<RootModel>()({
  state: initialState as CountState,
  reducers: {
    fetchPending(state, requestId: string) {
      return multiRequest.updatePending(state, requestId);
    },
    fetchSuccess(
      state,
      payload: {
        customerCount: number;
        churnCount: number;
        churnCountBeginTimestamp: string | null;
        churnCountEndTimestamp: string | null;
        contractElectricityCount: number;
        contractGasCount: number;
        contractHeatingCount: number;
        contractGlassFiberCount: number;
      },
      requestId: string
    ) {
      const churnCountBeginTimestamp =
        payload.churnCountBeginTimestamp === null
          ? null
          : moment(payload.churnCountBeginTimestamp).toDate();
      const churnCountEndTimestamp =
        payload.churnCountEndTimestamp === null
          ? null
          : moment(payload.churnCountEndTimestamp).toDate();
      const parsedPayload = {
        ...payload,
        churnCountBeginTimestamp,
        churnCountEndTimestamp,
      };
      return multiRequest.updateSuccess(parsedPayload, state, requestId);
    },
    fetchFail(state, requestId: string) {
      return multiRequest.updateFail(state, requestId);
    },
  },
  effects: (dispatch) => ({
    async fetchCount(dashboardFilter: DashboardFilterState, rootState) {
      const requestId = multiRequest.getRequestId();
      dispatch.count.fetchPending(requestId);

      const token = checkToken(rootState, () =>
        dispatch.count.fetchFail(requestId)
      );
      if (!token) return;

      try {
        const countResult = await api.fetchCount(token, dashboardFilter);
        dispatch.count.fetchSuccess(countResult, requestId);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.count.fetchFail(requestId);
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/count.ts